/**
 * "Svagaste ämnen" (slice D, P2-2): the topics with the lowest estimated träffsäkerhet among
 * those the student has actually tried. Pure, from the overview's chapter rows, so Progress and
 * the Tentaläge card on Home show the same list.
 *
 * - Only course-map topics (`eligible`) with at least `MIN_ITEMS` problems answered: one wrong
 *   answer is not yet a weak topic, and a topic never tried is "Plugga härnäst"'s business.
 * - Lowest mastery first; ties go to the topic with more evidence, then by chapter and id.
 */
import type { ChapterProgress, TopicProgress } from "./types";

export const WEAKEST_LIMIT = 5;
export const WEAKEST_MIN_ITEMS = 2;

export function weakestTopics(
  chapters: readonly Pick<ChapterProgress, "topics">[],
  limit = WEAKEST_LIMIT,
): TopicProgress[] {
  return chapters
    .flatMap((chapter) => chapter.topics)
    .filter((topic) => topic.eligible && topic.items >= WEAKEST_MIN_ITEMS)
    .sort(
      (a, b) =>
        a.mastery - b.mastery ||
        b.items - a.items ||
        a.chapter - b.chapter ||
        a.topicId.localeCompare(b.topicId),
    )
    .slice(0, limit);
}
